import RedacaoSettings from './RedacaoSettings';
import SectionContentHeading from '../ReusableComponents/SectionContentHeading';
import SectionButtons from '../ReusableComponents/SectionButtons';
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdOutlineRule, MdReply } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';
import TabPanel from "../ReusableComponents/TabPanel";
import TextReadMore from '../ReusableComponents/TextReadMore';
import { CircularProgress, Snackbar } from "@material-ui/core";
import ModalRedacao from './ModalRedacao';
import Redacoes from '../Redacoes/Redacoes';
import Provas from '../Provas/Provas';
import CandidatosVinculados from '../CandidatosVinculados/CandidatosVinculados';
import FiscaisVinculados from '../FiscaisVinculados/FiscaisVinculados';
import CorretoresVinculados from '../CorretoresVinculados/CorretoresVinculados';
import SalasProcesso from '../SalasProcesso/SalasProcesso';
import TextosApoio from './TextosApoio';
import ResultadosRedacao from './ResultadosRedacao';
import RedacaoIA from './RedacaoIA'; // Importe o novo componente

class ShowRedacoesProcesso extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/',
            loading_screen: true,
            roles: [],
            name: '',
            caminho: '',
            termos: '',
            loading_save: false,
            msgErro: '',
            loading_image: false,
            processo: {},
            redacao: {},
            show_more: false,

            activeTab: 0
        };

    }


    get_redacao_processo(id) {

        if (this.state.loading_screen == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/faculdade/get_redacao_processo/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_redacao_processo();
                    //   });
                }
                else {
                    // this.props.mudarUser(resp.user);
                    this.setState({
                        loading_screen: false, redacao: resp.redacao, processo: resp.redacao.processo
                    });
                    // if (resp.processo != null) {


                }




            } catch (err) {
                this.setState({ redirect: true });
                console.log(err);


            }

        })
            .catch((err) => {
                this.setState({ redirect: true });

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }






    componentDidMount() {
        let tab = new URLSearchParams(this.props.location.search).get('tab');
        if (tab !== undefined && tab !== null) this.setState({ activeTab: parseInt(tab) });
        else if (tab === null) this.setState({ activeTab: 0 });
        this.get_redacao_processo(this.props.match.params.id);
    }







    render() {
        const sections = [
                            { value: 0, label: 'Textos de apoio', icon: 'conteudos', description: 'Consulte e gerencie os textos de apoio da redação.' },
                            { value: 1, label: 'Resultados', icon: 'relatorios', description: 'Consulte as respostas e os resultados dos candidatos.', visible: this.state.redacao?.processo?.online==true },
                            { value: 2, label: 'Corrigir com IA', icon: 'ia', description: 'Solicite e acompanhe as correções por inteligência artificial.', visible: this.props.user?.empresa?.plan?.essay_ia==true },
                            { value: 'imprimir', label: 'Imprimir template', icon: 'imprimir', description: 'Abra a folha de redação para impressão em outra aba.', href: URL + 'api/faculdade/download_redacao_template/' + this.state.redacao.id + '?token=' + encodeURIComponent(this.props.token) }
                        ];

        if (this.state.loading_screen) return <SkeletonCoursePage />
        else return (
            <div style={{ position: "relative" }}>
                <div>
                    <div className="module-page module-details">
                    <div className="card module-card detail-summary hidethis"><div className="card-body">
                        <div style={{ float: 'right' }}>
                            <DefaultButton
                                bg="secondary"
                                text="Voltar"
                                icon={<RiArrowGoBackLine />}
                                search={'?tab=0'}
                                to={`/processos/show/${this.state.processo.id}`}
                            />
                        </div>
                        <div className="flex jcsb">
                            <h1 className="module-details-title">{this.state.redacao.name}</h1>
                        </div>


                        <button type="button" className="btn btn-outline-primary d-inline-flex align-items-center" style={{ gap: 8, borderRadius: 10 }} onClick={() => this.setState({ show_more: true })}>
                            <MdOutlineRule aria-hidden="true" /> Ver enunciado
                        </button>
                        <ModalRedacao showModal={this.state.show_more} setShowModal={(e) => this.setState({ show_more: e })} redacao_name={this.state.redacao.name} regras={this.state.redacao.enunciado} />

                        {/* <div style={{ width: "100%", marginBottom: 10, whiteSpace: 'pre',height:this.state.show_more==false?100:'fit-content',overflowY:this.state.show_more==false? 'hidden':'visible' }}>
                            <b style={{ float: "left", marginRight: "2px" }}>{'Regras:'} </b>
                            <br/>
                            <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: this.state.processo.regras }}>
                            </div>
                        </div> */}
                        {/* <div className="w100 flex align-center fdcolumn margin-bottom">
                            <div className="course-banner" style={{
                                backgroundImage: `url(${STORAGE_URL+ this.state.faculdade.logo})`,
                                backgroundSize: "contain",
                                backgroundRepeat:'no-repeat',
                                backgroundPositionX:'center',
                                width: "100%",
                                height: "200px",
                                borderRadius: "7px"
                            }} />
                        </div> */}
                        <RedacaoSettings redacao={this.state.redacao} />
                        <SectionButtons compact variant="modules" value={this.state.activeTab} items={sections} onChange={value => {
                                this.setState({ activeTab: value });
                                this.props.history.push({ search: `?tab=${value}` });
                            }} />
                    </div></div>
                    <div className="card module-card module-content"><div className="card-body">
                        <SectionContentHeading items={sections} value={this.state.activeTab} />
                        <TabPanel value={this.state.activeTab} index={0}>
                            <TextosApoio redacao_name={this.state.redacao.name} textos={this.state.redacao.textos_apoio} />

                        </TabPanel>
                        {this.state.redacao?.processo?.online==true && <TabPanel value={this.state.activeTab} index={1}>
                            {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
                            <ResultadosRedacao processo_name={this.state.processo.name} processo_id={this.state.processo.id} redacao_name={this.state.redacao.name} redacao_id={this.state.redacao.id} />

                        </TabPanel>}
                        {this.props.user?.empresa?.plan?.essay_ia==true && <TabPanel value={this.state.activeTab} index={2}>
                            <RedacaoIA
                                processo_name={this.state.processo.name}
                                processo_id={this.state.processo.id}
                                redacao_name={this.state.redacao.name}
                                redacao_id={this.state.redacao.id}
                            />
                        </TabPanel>}


                    </div></div>
                </div>
                </div>

            </div>
        );
    }


}
const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        user: state.AppReducer.user,
    }
);

const SkeletonCoursePage = () => {
    return (
        <div className="card">
            <div className="card-body">
                <div className="skeleton-title" />
                {/* <div className="skeleton-small-text skeleton-shimmer"/>
                <div className="skeleton-small-text skeleton-shimmer"/> */}
                <br />
                <div className="w100 flex jcc align-center">
                    <div className="skeleton-base skeleton-shimmer" style={{ width: "12em", height: "12em" }} />
                </div>
                <br />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "48px" }} />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "5em" }} />
                <div className="skeleton-small-button skeleton-shimmer" />
            </div>
        </div>
    );
}

export default connect(mapsStateToProps, { logout })(ShowRedacoesProcesso);


